import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/alertas",
    component: MasterLayout,
    children: [
      {
        path: "autorizar",
        name: "alertas.autorizar",
        component: () => import("@/views/alertas/autorizar/index.vue")
      },
      {
        path: "servicios",
        name: "alertas.servicios",
        component: () => import("@/views/alertas/servicios/index.vue")
      },
    ]
  }
]